import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./../../Styles/pages/components.scss";
import { ReactComponent as PlaceImgNotFound } from "./../../assets/images/icons/doctor.svg";
import { Fab } from "@mui/material";
import { ReactComponent as CallIcon } from "./../../assets/images/icons/Google SVGs/call.svg";
import { ReactComponent as CancelIcon } from "./../../assets/images/icons/Google SVGs/cancel.svg";
import DepartmentImgNotFoundVector from "./../../assets/images/department-not-found-vector.svg";
import haveAccess from "../../utilities/functions/haveAccess";
import { useSelector } from "react-redux";
import ShareLinkModal from "../../components/modals/share/shareModal";
import FloatTitleCard from "../../components/cards/floatTitleCard";

const DoctorProfile = () => {
  const isMobile = window.innerWidth >= 992 ? false : true;

  // #region auth parameter
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  const navigate = useNavigate();
  const { roles } = useSelector((state) => state.user);

  // #endregion
  const [loading, setLoading] = useState(false);

  // Extracting query parameters from the URL
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pl = queryParams.get("pl") ? queryParams.get("pl") : null; // Getting the value of 'pl' from the query string
  const dr = queryParams.get("dr") ? queryParams.get("dr") : null; // Getting the value of 'dr' from the query string
  const dep = queryParams.get("dep") ? queryParams.get("dep") : null; // Getting the value of 'dep' from the query string

  const [places, setPlaces] = useState();
  const [doctorFile, setDoctorFile] = useState(); // Doctor Picture Profile
  const [doctorTitle, setDoctorTitle] = useState();
  const [doctorFirstName, setDoctorFirstName] = useState();
  const [doctorLastName, setDoctorLastName] = useState();
  const [doctorOrgId, setDoctorOrgId] = useState(); // Doctor Originization ID
  const [doctorMobile, setDoctorMobile] = useState(); // change to calling Secretary
  const [doctorCity, setDoctorCity] = useState(); // change to calling Secretary
  const [doctorProvince, setDoctorProvince] = useState(); // change to calling Secretary
  const [doctorLastDgree, setDoctorLastDgree] = useState("");
  const [doctorSpecialties, setDoctorSpecialties] = useState([]);
  const [doctorDepPl, setDoctorDepPl] = useState([]); // Doctor's Place Department array

  // data for choose parent dep
  // const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState([]);
  const [place, setPlace] = useState([]);
  const [showPhone, setShowPhone] = useState(false);

  const getDoctorDetail = () => {
    axios
      .post(
        serverConfig.server.url + apiConfig.api.getAPIs.getDoctorProfile + dr,
        { user_id: dr },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setDoctorTitle(response.data.data.title);
          setDoctorFirstName(response.data.data.first_name);
          setDoctorLastName(response.data.data.last_name);
          // setDoctorMobile(response.data.data.mobile);
          setDoctorOrgId(response.data.data.organ_id);
          setDoctorCity(response.data.data.city_title);
          setDoctorProvince(response.data.data.province_title);
          setDoctorLastDgree(response.data.data.last_degree);
          response.data.data.doctor_specialties &&
            setDoctorSpecialties(response.data.data.doctor_specialties);
          setDoctorDepPl(response.data.data.department_places);
          response.data.data.file
            ? setDoctorFile(response.data.data.file)
            : setDoctorFile();

          response.data.data.department_places &&
            response.data.data.department_places
              .filter((e) => (dep ? e.department.id == dep : e))
              .filter((e) => (pl ? e.place.id == pl : e))
              .map((e) => {
                !doctorMobile && setDoctorMobile(e.department.support_phone);
              });
          !doctorMobile && setDoctorMobile("not-found");
          /*
           .city_id
           .files (array)
           .technical_phone (or support_phone?)
           .type (type of HC)
           .biography (or biography?)
           .address
          */
        } else {
          if (response.data.code == 404) {
            navigate("/404");
          } else if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  // const getDoctorsPlaceDepartments = () => {
  //   axios
  //     .post(
  //       serverConfig.server.url + apiConfig.api.publicAPIs.eventParameterReader,
  //       dep != null
  //         ? {
  //             place_id: parseInt(pl),
  //             department_id: parseInt(dep),
  //           }
  //         : {
  //             place_id: parseInt(pl),
  //           },
  //       {
  //         headers,
  //       }
  //     )
  //     .then((response) => {
  //       setLoading(false);
  //       if (response.data.status === "success") {
  //         if (!(departments.length > 0) && response.data.data.departments) {
  //           setDepartments(response.data.data.departments);
  //         }
  //         setPlaces(response.data.data.places);
  //       } else {
  //         if (typeof response.data.errors === typeof "String") {
  //           toast.error(response.data.errors);
  //         } else {
  //           response.data.errors.forEach((element) => {
  //             toast.error(element);
  //           });
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       toast.error("Error making API call:", error);
  //     });
  // };

  useEffect(() => {
    getDoctorDetail();
  }, []);

  useEffect(() => {
    setShowPhone(false);
  }, [department]);

  // useEffect(() => {
  //   getDoctorsPlaceDepartments();
  // }, []);

  // useEffect(() => {
  //   if (dep) {
  //     getDoctorsPlaceDepartments();
  //   }
  // }, []);

  return (
    <div className="pt-3">
      <FloatTitleCard title="اطلاعات پزشک">
        <div className="row">
          <div className="col d-flex justify-content-start">
            {doctorFile && doctorFile.length != 0 ? (
              <img
                className="doctor-image-box col col-auto object-fit-cover"
                src={doctorFile}
              />
            ) : (
              <PlaceImgNotFound className="doctor-image-box col col-auto object-fit-cover rounded-pill p-2 background-bootstrap-gray-200 me-2" />
            )}
            <div className="d-flex flex-column ms-2">
              <span className="fs-14 fw-medium color-bootstrap-gray-800 mb-1">
                {doctorTitle} {doctorFirstName} {doctorLastName}
              </span>

              {doctorSpecialties &&
                doctorSpecialties.map((e, index) => (
                  <span
                    key={index}
                    className="fs-12 fw-normal color-bootstrap-gray-600"
                  >
                    {e.education_title} {e.specialty_title}
                  </span>
                ))}
            </div>
          </div>
          <div className="col-auto d-flex justify-content-end align-items-start">
            <ShareLinkModal
              justIcon={false}
              text={
                (doctorTitle ? doctorTitle + " " : "") +
                doctorFirstName +
                " " +
                doctorLastName
              }
              subtext={doctorLastDgree}
              link={window.location.href}
              name={
                (doctorTitle ? doctorTitle + " " : "") +
                doctorFirstName +
                " " +
                doctorLastName
              }
            />
          </div>
          <div className="col-12">
            <hr className="color-bootstrap-gray-300 opacity-100" />
          </div>
          <div className="col-lg-6 col-12 mx-0">
            <div className="row">
              <div className="col d-flex flex-column fs-14">
                <div className="d-flex flex-row ps-2">
                  <span className="fw-medium color-bootstrap-gray-700">
                    شهر :
                  </span>
                  <span className="ms-2 fw-normal color-bootstrap-gray-600">
                    {doctorCity}
                  </span>
                </div>
              </div>
              <div className="col d-flex flex-column fs-14">
                <div className="d-flex flex-row ps-2">
                  <span className="fw-medium color-bootstrap-gray-700">
                    شماره نظام :
                  </span>
                  <span className="ms-2 fw-normal color-bootstrap-gray-600">
                    {doctorOrgId}
                  </span>
                </div>
              </div>
              {/* <div className="col d-flex flex-column fs-14">
              <div className="d-flex border-right flex-column ps-2">
                <span className="fw-normal color-bootstrap-gray-600">
                  شماره تماس
                </span>
                {doctorMobile != "not-found" ? (
                  <a
                    className="text-decoration-none color-bootstrap-gray-600"
                    href={`tel:${doctorMobile}`}
                  >
                    {doctorMobile}
                  </a>
                ) : (
                  <span>شماره‌ای ثبت نشده</span>
                )}
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </FloatTitleCard>
      <div className="pt-3 ">
        <FloatTitleCard title="ثبت نوبت">
          <div className="col-12 px-auto justify-content-center">
            {loading && (
              <span
                className="spinner-border spinner-border ms-1"
                role="status"
                aria-hidden="true"
              />
            )}

            <div className="row px-0 g-lg-4 g-2">
              {/* just for view */}
              {doctorDepPl &&
                doctorDepPl
                  .filter((e) => (dep ? e.department.id == dep : e))
                  .filter((e) => (pl ? e.place.id == pl : e))
                  .map((e, index) => (
                    <div key={index} className="col col-lg-6 col-12">
                      <div className="card border-radius-8  border-bootstrap-gray-300 background-bootstrap-gray-100">
                        <div
                          className="text-decoration-none"
                          // href={`/place?pl=${e.place.id}`}
                        >
                          <div className="card-header py-1 px-2 mx-2 mt-2 background-bootstrap-gray-200 border-0 border-radius-8">
                            <span className="d-flex fs-14 color-bootstrap-gray-700">
                              {e.department.file && (
                                <img
                                  className="pe-1"
                                  width={32}
                                  src={e.department.file}
                                  alt=""
                                />
                              )}
                              {!e.department.file && (
                                <img
                                  className="me-2"
                                  width={24}
                                  src={DepartmentImgNotFoundVector}
                                  alt=""
                                />
                              )}
                              {e.department.title}
                            </span>
                          </div>
                        </div>

                        <div className="card-body d-flex flex-column px-0 py-0 pb-2">
                          <span className="px-2 py-2 color-bootstrap-gray-600 fs-14">
                            {e.place.title}
                          </span>
                          <div className="card-footer border-bootstrap-gray-300 bg-transparent p-0">
                            <div className="d-flex flex-row mt-2">
                              <button
                                className="btn color-iso-blue-300 w-100 fs-14 fw-medium d-flex justify-content-center ms-2 me-1"
                                data-bs-target="#department-modal"
                                data-bs-toggle="modal"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  setDepartment(e.department);
                                  setPlace(e.place);
                                }}
                              >
                                اطلاعات دپارتمان
                              </button>
                              <button
                                className="btn btn-blue-300 border-radius-8 w-100 fs-14 fw-medium d-flex justify-content-center ms-1 me-2"
                                // data-bs-dismiss="modal"
                                onClick={() =>
                                  navigate(
                                    `/booking?${"pl=" + e.place.id}&${
                                      "dep=" + e.department.id
                                    }&${"dr=" + dr}`
                                  )
                                }
                              >
                                دریافت نوبت
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        </FloatTitleCard>
      </div>

      {haveAccess(roles, "show_shift") && (
        <Fab
          variant="extended"
          size="medium"
          // color="primary"
          className="d-flex ms-auto mt-2 fs-16 fw-medium btn-blue-300 rounded-pill py-2 px-4"
          sx={{ position: "sticky", bottom: isMobile ? "90px" : "12px" }}
          type="button"
          onClick={() => {
            navigate(`/shift-management${"?dr=" + dr}`);
          }}
        >
          شیفت کاری
        </Fab>
      )}
      {/* select department modal */}
      <div
        className="modal fade"
        id="department-modal"
        tabIndex="-1"
        aria-labelledby="department-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2">
              <span className="fs-16 fw-medium color-bootstrap-gray-900">
                اطلاعات دپارتمان
              </span>
              <CancelIcon
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setDepartment([]);
                  setPlace([]);
                  setShowPhone(false);
                }}
                width={24}
                className="ms-auto"
              />
            </div>

            <div className="modal-body py-0">
              <div className="d-flex flex-column align-items-start mt-12px mb-12px">
                <div className="card w-100 background-bootstrap-gray-100 color-bootstrap-gray-700 border-0 fs-14 fw-normal mt-12px mb-12px">
                  <div className="card-body d-flex row p-2">
                    <span>{place.title}</span>
                    <span className="color-bootstrap-gray-600">
                      {department.title}
                    </span>
                  </div>
                </div>

                {department.biography && (
                  <div className="card w-100 background-bootstrap-gray-100 color-bootstrap-gray-700 border-0 fs-12 fw-normal mt-12px mb-12px">
                    <div className="card-body d-flex row p-2">
                      <span
                        className="color-bootstrap-gray-600"
                        dangerouslySetInnerHTML={{
                          __html:
                            "<span class='color-bootstrap-gray-700'>توضیحات : </span>" +
                            department.biography.replace(/\r\n/g, "<br />"),
                        }}
                      />
                    </div>
                  </div>
                )}

                {department.support_phone && (
                  <div className="card w-100 background-bootstrap-gray-100 color-bootstrap-gray-700 border-0 fs-12 fw-normal">
                    <div className="card-body d-flex p-2">
                      <span className="me-auto">
                        <CallIcon width={20} className="me-1" />
                        تلفن دپارتمان
                      </span>
                      {showPhone ? (
                        <a
                          className="color-bootstrap-gray-600 text-decoration-none"
                          href={`tel:${department.support_phone}`}
                        >
                          {department.support_phone}
                        </a>
                      ) : (
                        <span
                          className="color-bootstrap-gray-600 text-decoration-none"
                          type="button"
                          onClick={() => {
                            setShowPhone(true);
                          }}
                        >
                          ****{department.support_phone.substring(0, 7)}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* <div className="modal-footer">
              <div className="d-flex col my-2 col-12">
                <div className="d-flex col">
                  <button
                    type="button"
                    className="btn btn-outline-primary w-100 mx-12px fw-medium"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setDepartment([]);
                    }}
                  >
                    بازگشت
                  </button>
                </div>

                <div className="d-flex col">
                  <button
                    type="button"
                    className="btn btn-primary w-100 me-12px fw-medium"
                    disabled={department.support_phone ? false : true}
                    onClick={() => {
                      navigate(`tel:${department.support_phone}`);
                    }}
                  >
                    تماس با دپارتمان
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorProfile;
